// Thư viện khối X (Twitter) cho Tự dựng — selector DÒ THẬT trên Chrome đã đăng nhập (2026-09-22 00:10, giao diện tiếng Việt):
// tìm kiếm /search?q=…&f=live: mỗi bài = <article data-testid="tweet">; chữ [data-testid="tweetText"]; tác giả [data-testid="User-Name"] a (href /handle);
// liên kết bài: a[href*="/status/"] (bọc <time>); nút trả lời [data-testid="reply"] (mở hộp thoại). Trang bài /handle/status/ID: ô trả lời
// TẠI CHỖ [data-testid="tweetTextarea_0"] (Draft.js contenteditable, aria-label "Đăng văn bản") + nút [data-testid="tweetButtonInline"]
// "Trả lời" (mờ tới khi có chữ); trả lời xong hiện ngay trong luồng bên dưới → hậu kiểm bằng chữ. Bài khoá trả lời ("Ai có thể trả lời")
// → không có ô nhập → dừng rõ. Đăng bài mới: /compose/post → hộp thoại tweetTextarea_0 + [data-testid="tweetButton"] "Đăng" → về /home
// và hiện toast [data-testid="toast"] ("Bài đăng của bạn đã được gửi"). Giới hạn 280 ký tự → max_words nhỏ + lớp kiểm "quá dài".
import type { KhoiMau } from "./tu-dung";
import { DK_THICH_LUOT } from "./ti-le-thich";

import { kemAnhHoc, TS_KEM_ANH_TAT_CA } from "./kem-anh";
import { themChiBaiLienQuan } from "./chi-lien-quan"; // (05/10) "Chỉ bình luận bài liên quan" co/khong cho mọi khối có bước chấm

export const X_URL = "https://x.com/";
const O_NHAP = '[data-testid="tweetTextarea_0"]';
// KÈM ẢNH (04/10/2026, src/shared/kem-anh.ts). Khảo sát thật 04/10 (x/o_tra_loi_da_go #64–#85, bai #101–#104): ô trả lời tại chỗ tweetTextarea_0 +
// [data-testid=toolBar] chứa button aria-label "Thêm ảnh hoặc video" và tweetButtonInline ĐÃ ĐO; ảnh trong bài là [data-testid=tweetPhoto] (aria-label
// "Hình ảnh") ĐÃ ĐO. VẪN GIẢ ĐỊNH (khảo sát không ghi phần tử ẩn / chưa đính ảnh thật): input[data-testid=fileInput] nằm trong CÙNG khung với
// tweetTextarea_0 (chuỗi tổ tiên đo được của ô nhập không thấy khung chung với toolBar trong 12 tầng); ảnh xem trước trong [data-testid=attachments];
// trả lời đăng xong có [data-testid=tweetPhoto] img trong article chứa câu vừa gửi.
export const X_KEM_ANH = { o_tep: 'input[data-testid="fileInput"], input[type="file"]', xem_truoc: '[data-testid="attachments"] img, img[src^="blob:"], img[src^="data:"]' };
export const X_HAU_KIEM_ANH = [{ t: "locator_visible" as const, target: { describe: "ảnh trong trả lời vừa đăng (bài chứa câu vừa gửi)", ladder: [
  { t: "xpath" as const, xpath: '(//article[@data-testid="tweet"][.//*[@data-testid="tweetText"][contains(normalize-space(.), {{ xpath_chu(cau_da_go) }})]]//*[@data-testid="tweetPhoto"]//img)[1]' },
] } }];

export const POST_LIST_SPEC = {
  mode: "list",
  list: { describe: "danh sách bài trong kết quả tìm kiếm X", ladder: [{ t: "css", sel: 'article[data-testid="tweet"]' }] },
  fields: {
    tac_gia: { sel: '[data-testid="User-Name"] a[href^="/"]', attr: "href", regex: "(/[A-Za-z0-9_]+)/?$" }, // href tuyệt đối → giữ "/handle" cuối để so với tai_khoan
    noi_dung: { sel: '[data-testid="tweetText"]', attr: "text", fallback: "longest_text" },
    lien_ket: { sel: 'a[href*="/status/"]', attr: "href" },
    // Bài QUẢNG CÁO = có nhãn "Quảng cáo"/"Ad" riêng một span (đo thật 2026-10-01, trang chủ: 4/4 bài quảng cáo có nhãn, không có <time>).
    // KHÔNG dùng [data-testid="placementTracking"]: trên X thật đó là khung theo dõi VIDEO (9/9 bài có video), dùng nó là bỏ oan bài video
    // và để lọt bài quảng cáo (tests/unit/dom/x-quang-cao.test.ts).
    quang_cao: { sel: "span", attr: "text", regex: "^(?:Quảng cáo|Ad|Promoted|Được quảng bá)$" },
    ma_bai: { sel: 'a[href*="/status/"]', attr: "href", regex: "/status/([0-9]+)" }, // số hiệu bài — tìm lại ĐÚNG bài trên bảng tin (luot_bang_tin)
    anh_url: { sel: null, attr: "anh_lon" }, // ảnh kèm bài — AI nhìn khi chữ ngắn
  },
  item_key: "lien_ket",
};

const TRA_LOI_ACTIONS = [
  { kind: "navigate", url: "{{item.lien_ket}}" },
  // L-42: vung "bai" — ô trả lời phải nằm trong nội dung chính/hộp thoại bài; ô soạn tin nhắn (DMDrawer/dmComposer, X Chat chat-drawer-*) luôn bị loại.
  { kind: "type", target: { describe: "ô trả lời tại chỗ dưới bài", vung: "bai", ladder: [
    { t: "css", sel: O_NHAP },
    { t: "css", sel: 'div[role="textbox"][contenteditable="true"][aria-multiline="true"]' },
    { t: "model", prompt: "ô nhập trả lời (contenteditable, aria-label 'Đăng văn bản'/'Post text') ngay dưới bài đang xem" },
  ] }, text: "{{item.tra_loi}}" },
  { kind: "click", target: { describe: "nút Trả lời (gửi)", ladder: [
    { t: "css", sel: '[data-testid="tweetButtonInline"]' },
    { t: "css", sel: '[data-testid="tweetButton"]' },
    { t: "model", prompt: "nút 'Trả lời' / 'Reply' để gửi câu trả lời vừa gõ" },
  ] } },
];

export const DANG_BAI_ACTIONS = [
  { kind: "navigate", url: "{{goc}}compose/post" },
  { kind: "type", target: { describe: "ô soạn bài đăng", ladder: [
    { t: "css", sel: `[role="dialog"] ${O_NHAP}` },
    { t: "css", sel: O_NHAP },
    { t: "model", prompt: "ô soạn bài đăng mới (contenteditable) trong hộp thoại" },
  ] }, text: "{{bai}}" },
  { kind: "click", target: { describe: "nút Đăng", ladder: [
    // X 2026-09-29 (đo thật, elementFromPoint): /compose/post vẽ HỘP THOẠI soạn bài đè lên ô soạn tại chỗ của trang chủ. Nút Đăng của hộp
    // thoại là tweetButton (bấm được); tweetButtonInline là nút của ô soạn phía sau lớp phủ → thử nó trước sẽ báo "phần tử bị che".
    // (2026-09-22 trang chưa có hộp thoại đè: khi đó tweetButtonInline là nút thật — giữ làm nấc dự phòng.)
    { t: "css", sel: '[role="dialog"] [data-testid="tweetButton"]' },
    { t: "css", sel: '[data-testid="tweetButtonInline"]' },
    { t: "css", sel: '[data-testid="tweetButton"]' },
    { t: "model", prompt: "nút 'Đăng' / 'Post' để đăng bài vừa soạn" },
  ] } },
];

// Hội đồng trên X: mỗi bài/trả lời là article[data-testid=tweet] có tweetText, like, reply (bản đồ dò thật). Trả lời ĐÚNG một
// trả lời của nick khác = bấm liên kết /status/ của chính article đó (mỗi trả lời trên X là một bài riêng) rồi trả lời tại chỗ
// bằng ô tweetTextarea_0 + tweetButtonInline (đường đã đăng thật 2026-09-22).
const X_BAI = '//article[@data-testid="tweet"][.//*[@data-testid="tweetText"][contains(normalize-space(.), {{ xpath_chu(chu_binh_luan) }})]]';
const X_THICH_ACTIONS = [
  { kind: "navigate", url: "{{bai_url}}" },
  { kind: "click", target: { describe: "nút Thích của bài chứa chữ đã cho", ladder: [
    { t: "xpath", xpath: `(${X_BAI}//*[@data-testid="like"])[1]` },
    { t: "model", prompt: "nút Thích (trái tim) của bài chứa chữ {{chu_binh_luan}}" },
  ] } },
];
// CHỐT trang đích sau cú bấm liên kết (2026-10-02, E2E dieu-huong-cham DH1/DH2): runner KHÔNG chờ trang mới giữa các thao tác của một bước —
// trang của trả lời tải chậm thì ô trả lời tại chỗ của BÀI CHÍNH luồng cũ (bai_url) vẫn đang hiện → gõ + bấm Trả lời vào bài khác (và hậu kiểm
// "thấy chữ" đạt oan ngay trên trang cũ). Nay chờ tới khi BÀI CHÍNH của trang (article tabindex -1 — đo thật 2026-10-01, xem X_BAI_CHINH) là bài
// chứa đúng chữ cần đỡ rồi mới gõ; không bao giờ thấy (bài bị xoá, trang lỗi) → bước dừng, không gõ vào đâu. Không có nấc AI (không đoán).
const X_CHOT_BAI_CHINH = { kind: "scroll", target: { describe: "bài chính của trang vừa mở là đúng bài chứa chữ đã cho (chờ trang đích, không gõ trên trang cũ)", ladder: [
  { t: "xpath", xpath: '(//article[@data-testid="tweet"][@tabindex="-1"][.//*[@data-testid="tweetText"][contains(normalize-space(.), {{ xpath_chu(chu_binh_luan) }})]])[1]' },
] } };
const X_TRA_LOI_MOT_ACTIONS = [
  { kind: "navigate", url: "{{bai_url}}" },
  { kind: "click", target: { describe: "liên kết mở riêng bài chứa chữ đã cho", ladder: [
    { t: "xpath", xpath: `(${X_BAI}//a[contains(@href,"/status/")])[1]` },
    { t: "model", prompt: "liên kết thời gian đăng (mở riêng bài) của bài chứa chữ {{chu_binh_luan}}" },
  ] } },
  X_CHOT_BAI_CHINH,
  { ...TRA_LOI_ACTIONS[1]!, text: "{{cau_tra_loi}}" },
  TRA_LOI_ACTIONS[2]!,
];
const X_BINH_LUAN_MOT_ACTIONS = [{ kind: "navigate", url: "{{bai_url}}" }, { ...TRA_LOI_ACTIONS[1]!, text: "{{binh_luan}}" }, TRA_LOI_ACTIONS[2]!];

// ===================== X — THAO TÁC NHƯ NGƯỜI (2026-10-01): lướt bảng tin, nghỉ, đăng lại, trích dẫn =====================
// Đo thật Edge #2 (2026-10-01, CHỈ đọc DOM): trang chủ /home và kết quả tìm đều là article[data-testid=tweet] (tabindex 0); nút trong role=group:
// reply / retweet ("Đăng lại") / like ("Thích") / bookmark. Thích xong data-testid đổi like → unlike (như thich_bai). Trang bài /<h>/status/<id>:
// bài CHÍNH là article[tabindex="-1"] (bài trả lời bên dưới tabindex 0). Menu Đăng lại (khảo sát bot trên trang thật 2026-09-22):
// [data-testid=Dropdown] gồm [data-testid=retweetConfirm] "Đăng lại" và a[role=menuitem][href="/compose/post"] "Trích dẫn"; Trích dẫn mở hộp thoại
// soạn (tweetTextarea_0 + tweetButton) như dang_bai. Đã đăng lại → nút thành [data-testid=unretweet] — CHƯA kiểm trên trang thật (không được bấm
// Đăng lại khi đọc), suy theo cặp like/unlike. Tìm lại ĐÚNG bài trên bảng tin theo số hiệu (ma_bai) — X ảo hoá danh sách (bài cuộn qua bị gỡ khỏi
// DOM) nên không dùng vị trí _index. Thêm "/" cuối để /status/123 không khớp nhầm /status/1234.
const X_BAI_SO = '//article[@data-testid="tweet"][.//a[contains(concat(@href, "/"), "/status/{{item.ma_bai}}/")]]';
const X_BAI_CHINH = 'article[data-testid="tweet"][tabindex="-1"]';
const X_LUOT_CUON = [{ kind: "scroll", target: { describe: "bài đang lướt tới trên bảng tin", ladder: [{ t: "xpath", xpath: `(${X_BAI_SO})[1]` }] } }];
// Không có nấc "model" ở thao tác bật/tắt (Thích, Đăng lại): đoán sai = bỏ thích / bỏ đăng lại của người khác. Không thấy nút trạng thái CHƯA làm → dừng mục.
const X_LUOT_THICH = [{ kind: "click", target: { describe: "nút Thích của bài đang đọc (chỉ khi chưa thích)", ladder: [{ t: "xpath", xpath: `(${X_BAI_SO}//*[@data-testid="like"])[1]` }] } }];
const X_LUOT_DA_THICH = [{ t: "locator_visible", target: { describe: "nút Bỏ thích của bài vừa thích", ladder: [{ t: "xpath", xpath: `(${X_BAI_SO}//*[@data-testid="unlike"])[1]` }] } }];
const X_MO_MENU_DANG_LAI = { kind: "click", target: { describe: "nút Đăng lại của bài chính (mở menu Đăng lại / Trích dẫn)", ladder: [
  { t: "css", sel: `${X_BAI_CHINH} [data-testid="retweet"]` },
  { t: "xpath", xpath: '(//article[@data-testid="tweet"][@tabindex="-1"]//*[@data-testid="retweet"])[1]' },
] } };
const X_DANG_LAI_ACTIONS = [
  { kind: "navigate", url: "{{bai_url}}" },
  X_MO_MENU_DANG_LAI,
  { kind: "click", target: { describe: "mục 'Đăng lại' trong menu", ladder: [
    { t: "css", sel: '[data-testid="Dropdown"] [data-testid="retweetConfirm"]' },
    { t: "css", sel: '[data-testid="retweetConfirm"]' },
  ] } },
];
// Trích dẫn bài MÌNH ĐÃ đăng lại (vd kịch bản đăng lại → nghỉ → trích dẫn): nút đã thành "unretweet", menu của nó vẫn có "Trích dẫn"
// (cạnh "Hủy đăng lại" — KHÔNG bấm mục đó). Chỉ trích dẫn được dùng nấc này; đăng lại thì không (đã đăng lại rồi là dừng).
const X_MO_MENU_TRICH_DAN = { ...X_MO_MENU_DANG_LAI, target: { ...X_MO_MENU_DANG_LAI.target, ladder: [...X_MO_MENU_DANG_LAI.target.ladder, { t: "css", sel: `${X_BAI_CHINH} [data-testid="unretweet"]` }] } };
const X_TRICH_DAN_ACTIONS = [
  { kind: "navigate", url: "{{bai_url}}" },
  X_MO_MENU_TRICH_DAN,
  { kind: "click", target: { describe: "mục 'Trích dẫn' trong menu", ladder: [
    { t: "css", sel: '[data-testid="Dropdown"] a[role="menuitem"][href="/compose/post"]' },
    { t: "xpath", xpath: '(//*[@role="menu"]//a[@role="menuitem"][contains(@href,"/compose/post")])[1]' },
  ] } },
  { kind: "type", target: { describe: "ô soạn lời trích dẫn trong hộp thoại", ladder: [{ t: "css", sel: `[role="dialog"] ${O_NHAP}` }] }, text: "{{trich_dan}}" },
  { kind: "click", target: { describe: "nút Đăng của hộp thoại trích dẫn", ladder: [{ t: "css", sel: '[role="dialog"] [data-testid="tweetButton"]' }] } },
];
// ===================== X — TRẢ LỜI NGƯỜI ĐÃ TRẢ LỜI BÀI CỦA MÌNH (L-72, 2026-10-02) =====================
// Selector lấy từ khối/khảo sát X đã đo thật (KHÔNG truy cập X khi dựng): link Hồ sơ a[data-testid=AppTabBar_Profile_Link] href="/<handle>" (khảo sát
// ho_so_toi, L-61); trang bài: bài CHÍNH article[data-testid=tweet][tabindex="-1"], trả lời bên dưới là article tabindex 0 (khảo sát bai_tu_bang_tin);
// tác giả [data-testid=User-Name] a[href^="/"]; giờ đăng là a[href*="/status/"] bọc <time>; ô trả lời TẠI CHỖ tweetTextarea_0 + tweetButtonInline
// (đường đã đăng thật 2026-09-22, TRA_LOI_ACTIONS — giữ rào vùng 'bai' L-42: không bao giờ gõ vào ô tin nhắn DMDrawer/dmComposer).
// Bài ghim / bài mình đăng lại trên trang Hồ sơ có dòng [data-testid=socialContext] ("Đã ghim", "Bạn đã đăng lại") → bỏ khi chọn bài MỚI NHẤT; nấc 2
// (không lọc socialContext) chỉ để không kẹt nếu X đổi nhãn đó. Bên dưới các trả lời X có mục "Khám phá thêm" (bài của người lạ, cũng là article):
// nấc 1 của danh sách bỏ mọi ô sau ô có tiêu đề h2; lúc GỬI còn CHỐT bài gốc (số hiệu ma_goc_ph) phải có trên trang trả lời — trang của bài lạ không
// có → mục bị bỏ (không gõ).
const X_PH_HO_SO = { kind: "click", target: { describe: "link Hồ sơ của nick đang đăng nhập (thanh bên)", ladder: [
  { t: "css", sel: 'a[data-testid="AppTabBar_Profile_Link"]' },
  { t: "xpath", xpath: '(//a[@data-testid="AppTabBar_Profile_Link"])[1]' },
] } };
// Tác giả = nick đang đăng nhập: href "/<handle>" (X thật) khớp không phân biệt hoa thường, so cả dấu "/" cuối để /toi không khớp nhầm /toiabc.
const X_HOA = '"ABCDEFGHIJKLMNOPQRSTUVWXYZ", "abcdefghijklmnopqrstuvwxyz"';
const X_PH_CUA_MINH = `[.//*[@data-testid="User-Name"]//a[contains(concat(translate(@href, ${X_HOA}), "/"), concat(translate({{ xpath_chu(nick_ph) }}, ${X_HOA}), "/"))]]`;
const X_PH_BAI_MOI = { kind: "click", target: { describe: "giờ đăng của bài MỚI NHẤT do chính mình đăng (bỏ bài ghim, bài đăng lại)", ladder: [
  { t: "xpath", xpath: `(//article[@data-testid="tweet"][not(.//*[@data-testid="socialContext"])]${X_PH_CUA_MINH}//a[contains(@href,"/status/")][.//time])[1]` },
  { t: "xpath", xpath: `(//article[@data-testid="tweet"]${X_PH_CUA_MINH}//a[contains(@href,"/status/")][.//time])[1]` },
] } };
const X_PH_LIST_SPEC = {
  mode: "list",
  list: { describe: "các trả lời dưới bài đang mở (không gồm bài chính, không gồm mục Khám phá thêm)", ladder: [
    { t: "css", sel: 'div[data-testid="cellInnerDiv"]:not(div[data-testid="cellInnerDiv"]:has(h2) ~ div) article[data-testid="tweet"]:not([tabindex="-1"])' },
    { t: "css", sel: 'article[data-testid="tweet"]:not([tabindex="-1"])' },
  ] },
  fields: {
    tac_gia: { sel: '[data-testid="User-Name"] a[href^="/"]', attr: "href", regex: "(/[A-Za-z0-9_]+)/?$" },
    noi_dung: { sel: '[data-testid="tweetText"]', attr: "text", fallback: "longest_text" },
    lien_ket: { sel: 'a[href*="/status/"]:has(time)', attr: "href", alt: ['a[href*="/status/"]'] },
    ma_bai: { sel: 'a[href*="/status/"]:has(time)', attr: "href", regex: "/status/([0-9]+)", alt: ['a[href*="/status/"]'] },
    quang_cao: { sel: "span", attr: "text", regex: "^(?:Quảng cáo|Ad|Promoted|Được quảng bá)$" },
    anh_url: { sel: null, attr: "anh_lon" },
  },
  item_key: "lien_ket",
};
const X_PH_GUI_ACTIONS = [
  { kind: "navigate", url: "{{item.lien_ket}}" },
  { kind: "scroll", target: { describe: "bài gốc của mình phía trên trả lời (chứng tỏ trả lời này thuộc bài của mình)", ladder: [
    { t: "xpath", xpath: '(//article[@data-testid="tweet"][.//a[contains(concat(@href, "/"), "/status/{{ma_goc_ph}}/")]])[1]' },
  ] } },
  { ...TRA_LOI_ACTIONS[1]!, text: "{{item.tra_loi}}" },
  TRA_LOI_ACTIONS[2]!,
];

// Tỉ lệ thích khi lướt (trần 30%): MỖI bài được thích với XÁC SUẤT = tỉ lệ (người dùng chốt 03/10). Biểu thức `when` (DK_THICH_LUOT) giữ nguyên
// chữ-từng-chữ — bot ≤ 0.1.47 đọc nó TẤT ĐỊNH theo vị trí (10% = bài thứ 10); runner mới nhận ra nó và bốc ngẫu nhiên — xem src/shared/ti-le-thich.ts.
// Lướt mà lần này CHƯA TỚI LƯỢT thích bài nào (không bốc trúng bài nào, hoặc tỉ lệ 0) = không có việc, không phải lỗi
// (lỗi thật 03/10: "Mẫu 24h · X-A" → "Nháp: 0 việc SẼ làm khi chạy thật — when không thoả" chặn Chạy thật). {{ts.ti_le_thich}} điền lúc dịch sơ đồ.
const LY_DO_CHUA_TOI_LUOT_THICH = "Lần này chưa tới lượt thích bài nào (tỉ lệ thích {{ts.ti_le_thich}}%) — chỉ lướt xem";
const TS_TI_LE_THICH = { ten: "ti_le_thich", moTa: "phần trăm bài được bấm Thích khi lướt (0-30; 0 = chỉ xem, không thích bài nào)", kieu: "so" as const, min: 0, max: 30, macDinh: "10" };

// Bài của mình CHƯA AI trả lời (bước đếm đọc "0") → các bước lấy/chọn/soạn/gửi bị `when` bỏ: KHÔNG CÓ VIỆC để làm, không phải lỗi/cảnh báo
// (lỗi thật 03/10: Boss hiện "⚠ Nháp: 0 việc SẼ làm khi chạy thật — when không thoả" và chặn Chạy thật). Câu này hiện trên thẻ Chạy + Boss.
const LY_DO_KHONG_TRA_LOI = "Bài của bạn chưa có ai trả lời — không có gì để làm lúc này";

// ===================== ĐỂ TRỐNG ĐỊA CHỈ BÀI → TỰ TÌM BÀI (05/10/2026, src/shared/tu-dung.ts BienTheTuTim) =====================
// Trả lời / đăng lại / trích dẫn MỘT bài mà người dùng không ghi địa chỉ: tìm bài MỚI NHẤT theo từ khoá của kịch bản (như tim_bai, từ khoá máy điền lúc lắp),
// đọc nick đang đăng nhập (link Hồ sơ — như tra_loi; không có = chưa đăng nhập → bước lỗi, dừng), bỏ bài quảng cáo, bài quá ngắn, bài của CHÍNH nick, bài đã
// làm (sổ cái của từng việc), [AI chấm liên quan khi có sản phẩm/mục tiêu], làm ĐÚNG MỘT bài. Nhiều bước cùng để trống (đăng lại → trích dẫn…) dùng CHUNG một
// lần tìm (chung "x_bai"). Selector = các khối đã đo thật (tim_bai, tra_loi, dang_lai, trich_dan).
const X_DK_TU_TIM = "len(trim(tk_bai_x)) > 0";
const X_TIM_CHUNG = `  - id: tk_bai_x
    template: "{{ts.tu_khoa_tu_tim}}"
    into: tk_bai_x

  - id: tim_bai_x_tu_tim
    when: "${X_DK_TU_TIM}"
    on: web
    do: "tìm bài X mới nhất theo từ khoá {{tk_bai_x}}"
    expect: "url chứa /search"

  - id: lay_nick_x_tu_tim
    when: "${X_DK_TU_TIM}"
    on: web
    extract: "nick đang đăng nhập (link Hồ sơ ở thanh bên)"
    into: nick_x_tu_tim

  - id: lay_bai_x_tu_tim
    when: "${X_DK_TU_TIM}"
    on: web
    extract: "bài kết quả tìm kiếm: tac_gia, noi_dung, lien_ket, quang_cao"
    into: ds_bai_x

  - id: loc_bai_x_tu_tim
    when: "${X_DK_TU_TIM}"
    filter: "len(str(nick_x_tu_tim)) > 1 and len(str(item.lien_ket)) > 0 and len(str(item.noi_dung)) > 20 and not item.quang_cao and lower(str(item.tac_gia)) != lower(str(nick_x_tu_tim))"
    into: ds_bai_x`;
const X_HOC_TIM_CHUNG = {
  tim_bai_x_tu_tim: { actions: [{ kind: "navigate", url: "{{goc}}search?q={{ts_url.tu_khoa_tu_tim}}&f=live" }] },
  lay_nick_x_tu_tim: { extract_spec: { mode: "single", target: { describe: "link Hồ sơ của nick đang đăng nhập (không có = chưa đăng nhập → dừng)", ladder: [{ t: "css", sel: 'a[data-testid="AppTabBar_Profile_Link"]' }] }, attr: "href", regex: "(/[A-Za-z0-9_]+)/?$" } },
  lay_bai_x_tu_tim: { extract_spec: POST_LIST_SPEC, ghi_khi_rong: "không tìm thấy bài nào theo từ khoá — không có gì để làm" },
  loc_bai_x_tu_tim: { ly_do_bo: "bài quảng cáo, quá ngắn, không có liên kết, hoặc bài của CHÍNH nick" },
};
const X_LY_DO_KHONG_BAI = (viec: string) => `Không tìm được bài phù hợp để ${viec} lúc này (không có từ khoá/sản phẩm/mục tiêu để tìm, hoặc bài tìm được đều là quảng cáo / quá ngắn / của nick mình / đã ${viec} / không liên quan) — không ${viec} bừa`;
const X_TU_TIM_TRA_LOI = {
  thamSo: "bai_url", chung: "x_bai", yamlTim: X_TIM_CHUNG,
  yamlSteps: `  - id: chon_bai_tl_x_tu_tim
    when: "${X_DK_TU_TIM}"
    filter: "item.lien_ket not in ledger.da_tra_loi"
    into: ds_bai_x

  - id: soan_bai_tl_x_tu_tim
    for_each: ds_bai_x
    max_items: 1
    when: "${X_DK_TU_TIM}"
    generate:
      input: "Bài của {{item.tac_gia}} trên X: {{item.noi_dung}} — (bạn là một người dùng khác, không phải tác giả bài; không dùng hashtag) viết trả lời với góc nhìn: {{goc_nhin}}"
      guide: knowledge
      max_words: 35
      max_chars: 280
      anh: item.anh_url
    into: item.tra_loi

  - id: gui_bai_tl_x_tu_tim
    for_each: ds_bai_x
    max_items: 1
    when: "${X_DK_TU_TIM} and len(ds_bai_x) > 0"
    ly_do_bo_qua: "${X_LY_DO_KHONG_BAI("trả lời")}"
    on: web
    do: "mở bài {{item.lien_ket}}, gõ {{item.tra_loi}} vào ô trả lời rồi bấm Trả lời"
    expect: "thấy chữ '{{item.tra_loi}}'"
    risk: high
    timeout: 60s
    on_item_error: skip
    ledger: da_tra_loi`,
  learned: { ...X_HOC_TIM_CHUNG, chon_bai_tl_x_tu_tim: { ly_do_bo: "nick đã trả lời bài này ở lần chạy trước (sổ cái)" },
    gui_bai_tl_x_tu_tim: { actions: TRA_LOI_ACTIONS, postcondition: [{ t: "url_contains", s: "/status/" }, { t: "text_visible", text: "{{item.tra_loi}}" }], kem_anh: kemAnhHoc(1, X_HAU_KIEM_ANH, { ...X_KEM_ANH, ngu_canh: "{{item.noi_dung}}" }) } },
  params: { goc_nhin: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của nick này" } },
  chamPhuHop: { danhSach: "ds_bai_x", truong: "noi_dung", truocBuoc: "soan_bai_tl_x_tu_tim", maxItemsTu: "__mot_muc", anh: "anh_url" },
};
const X_DANG_LAI_MUC_ACTIONS = X_DANG_LAI_ACTIONS.map((a, i) => (i === 0 ? { kind: "navigate", url: "{{item.lien_ket}}" } : a));
const X_DA_DANG_LAI = { t: "dom_exists" as const, sel: `${X_BAI_CHINH} [data-testid="unretweet"]` };
const X_TU_TIM_DANG_LAI = {
  thamSo: "bai_url", chung: "x_bai", yamlTim: X_TIM_CHUNG,
  yamlSteps: `  - id: chon_bai_dl_x_tu_tim
    when: "${X_DK_TU_TIM}"
    filter: "item.lien_ket not in ledger.da_dang_lai"
    into: ds_bai_x

  - id: dang_lai_x_tu_tim
    for_each: ds_bai_x
    max_items: 1
    when: "${X_DK_TU_TIM} and len(ds_bai_x) > 0"
    ly_do_bo_qua: "${X_LY_DO_KHONG_BAI("đăng lại")}"
    on: web
    do: "mở {{item.lien_ket}}, bấm Đăng lại rồi chọn Đăng lại"
    expect: "bài chính chuyển sang đã đăng lại"
    risk: high
    idempotent: unsafe
    timeout: 45s
    on_item_error: skip
    ledger: da_dang_lai`,
  learned: { ...X_HOC_TIM_CHUNG, chon_bai_dl_x_tu_tim: { ly_do_bo: "nick đã đăng lại bài này ở lần chạy trước (sổ cái)" },
    dang_lai_x_tu_tim: { actions: X_DANG_LAI_MUC_ACTIONS, postcondition: [X_DA_DANG_LAI], bo_qua_khi: [{ khi: X_DA_DANG_LAI, ghi: "bài đã được nick đăng lại từ trước — không bấm (bấm lần hai là huỷ đăng lại)" }] } },
  chamPhuHop: { danhSach: "ds_bai_x", truong: "noi_dung", truocBuoc: "dang_lai_x_tu_tim", maxItemsTu: "__mot_muc", anh: "anh_url" },
};
const X_TRICH_DAN_MUC_ACTIONS = X_TRICH_DAN_ACTIONS.map((a, i) => (i === 0 ? { kind: "navigate", url: "{{item.lien_ket}}" } : a.kind === "type" ? { ...a, text: "{{item.trich_dan}}" } : a));
const X_TU_TIM_TRICH_DAN = {
  thamSo: "bai_url", chung: "x_bai", yamlTim: X_TIM_CHUNG,
  yamlSteps: `  - id: chon_bai_td_x_tu_tim
    when: "${X_DK_TU_TIM}"
    filter: "item.lien_ket not in ledger.da_trich_dan"
    into: ds_bai_x

  - id: soan_trich_dan_x_tu_tim
    for_each: ds_bai_x
    max_items: 1
    when: "${X_DK_TU_TIM}"
    generate:
      input: "Bài gốc trên X của {{item.tac_gia}}: {{item.noi_dung}} — viết lời TRÍCH DẪN (quote) ngắn như một người dùng khác đọc thấy đáng chia sẻ, góc nhìn: {{goc_nhin}} (tối đa 280 ký tự, KHÔNG dùng hashtag, không liên kết, không nhắc lại nguyên văn bài gốc)"
      guide: knowledge
      max_words: 40
      max_chars: 280
      anh: item.anh_url
    into: item.trich_dan

  - id: gui_trich_dan_x_tu_tim
    for_each: ds_bai_x
    max_items: 1
    when: "${X_DK_TU_TIM} and len(ds_bai_x) > 0"
    ly_do_bo_qua: "${X_LY_DO_KHONG_BAI("trích dẫn")}"
    on: web
    do: "mở {{item.lien_ket}}, bấm Đăng lại → Trích dẫn, gõ {{item.trich_dan}} rồi bấm Đăng"
    expect: "thấy chữ 'đã được gửi'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    on_item_error: skip
    ledger: da_trich_dan`,
  learned: { ...X_HOC_TIM_CHUNG, chon_bai_td_x_tu_tim: { ly_do_bo: "nick đã trích dẫn bài này ở lần chạy trước (sổ cái)" },
    gui_trich_dan_x_tu_tim: { actions: X_TRICH_DAN_MUC_ACTIONS, postcondition: [{ t: "dom_exists", sel: '[data-testid="toast"]' }] } },
  params: { goc_nhin: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của nick này" } },
  chamPhuHop: { danhSach: "ds_bai_x", truong: "noi_dung", truocBuoc: "soan_trich_dan_x_tu_tim", maxItemsTu: "__mot_muc", anh: "anh_url" },
};
const X_MO_TA_DIA_CHI = "Không bắt buộc — để trống thì bot tự tìm bài phù hợp theo từ khoá (bài mới nhất của bước Tìm / sản phẩm / mục tiêu)";

export const KHOI_X: KhoiMau[] = themChiBaiLienQuan([
  {
    ten: "tim_bai",
    moTa: "Tìm bài mới nhất trên X theo từ khoá rồi lấy danh sách (tac_gia, noi_dung, lien_ket, quang_cao) vào biến ds_bai",
    thamSo: [{ ten: "tu_khoa", moTa: "từ khoá tìm bài, tiếng Việt có dấu được; nhiều từ khoá cách nhau bằng dấu |; mỗi lần chạy dùng một từ khoá", kieu: "chuoi", batBuoc: true }],
    params: { tu_khoa: { type: "string", default: "{{ts.tu_khoa}}", label: "Từ khoá tìm bài" } },
    yamlSteps: `  - id: tim_bai
    on: web
    do: "tìm bài X mới nhất theo từ khoá {{tu_khoa}}"
    expect: "url chứa /search"

  - id: lay_bai
    on: web
    extract: "bài kết quả tìm kiếm: tac_gia, noi_dung, lien_ket, quang_cao"
    into: ds_bai
    min_items: 1`,
    learned: {
      tim_bai: { actions: [{ kind: "navigate", url: "{{goc}}search?q={{tu_khoa}}&f=live" }] },
      lay_bai: { extract_spec: POST_LIST_SPEC },
    },
  },
  {
    ten: "tra_loi",
    moTa: "Với danh sách ds_bai đã có: bỏ bài quảng cáo, bài quá ngắn, bài của chính mình và bài đã trả lời (sổ cái); AI soạn câu trả lời ngắn (≤ 280 ký tự) theo knowledge; mở bài, gõ vào ô trả lời tại chỗ và bấm Trả lời (rủi ro cao, ghi sổ cái)",
    thamSo: [
      { ten: "so_bai", moTa: "số bài tối đa sẽ trả lời trong một lần chạy (1-5)", kieu: "so", batBuoc: true, min: 1, max: 5 },
      { ten: "tai_khoan", moTa: "handle X của mình dạng /handle — thường bỏ trống: máy tự đọc nick đang đăng nhập trên trang (link Hồ sơ ở thanh bên) để KHÔNG trả lời chính mình; chỉ điền khi người dùng nói rõ handle", kieu: "chuoi", macDinh: "" },
      ...TS_KEM_ANH_TAT_CA,
    ],
    params: { tai_khoan: { type: "string", default: "{{ts.tai_khoan}}", label: "Handle của mình (/handle) — bỏ trống thì không trả lời bài nào" } },
    chamPhuHop: { danhSach: "ds_bai", truong: "noi_dung", truocBuoc: "soan", maxItemsTu: "so_bai", anh: "anh_url" },
    // L-53: AI từng chép ví dụ handle trong mô tả tham số → bộ lọc không loại bài của nick thật. Máy TỰ ĐỌC nick đang đăng nhập; lọc cả hai.
    yamlSteps: `  - id: lay_tai_khoan
    on: web
    extract: "nick đang đăng nhập (link Hồ sơ ở thanh bên)"
    into: tai_khoan_trang

  - id: chon_bai
    filter: "(len(tai_khoan) > 0 or len(tai_khoan_trang) > 0) and len(item.noi_dung) > 20 and not item.quang_cao and item.tac_gia != tai_khoan and item.tac_gia != tai_khoan_trang and item.lien_ket not in ledger.da_tra_loi"

  - id: soan
    for_each: ds_bai
    max_items: {{ts.so_bai}}
    generate:
      input: "Bài của {{item.tac_gia}} trên X: {{item.noi_dung}} — (bạn là một người dùng khác, không phải tác giả bài; không dùng hashtag)"
      guide: knowledge
      max_words: 35
      max_chars: 280
      anh: item.anh_url
    into: item.tra_loi

  - id: gui_tra_loi
    for_each: ds_bai
    max_items: {{ts.so_bai}}
    on: web
    do: "mở bài {{item.lien_ket}}, gõ {{item.tra_loi}} vào ô trả lời rồi bấm Trả lời"
    expect: "thấy chữ '{{item.tra_loi}}'"
    risk: high
    timeout: 60s
    on_item_error: skip
    ledger: da_tra_loi`,
    learned: {
      // Đo thật (khảo sát X): a[data-testid="AppTabBar_Profile_Link"] href="/<handle>" ở thanh bên mọi trang khi đã đăng nhập.
      lay_tai_khoan: { extract_spec: { mode: "single", target: { describe: "link Hồ sơ của nick đang đăng nhập", ladder: [{ t: "css", sel: 'a[data-testid="AppTabBar_Profile_Link"]' }] }, attr: "href", regex: "(/[A-Za-z0-9_]+)/?$" } },
      gui_tra_loi: { actions: TRA_LOI_ACTIONS, postcondition: [{ t: "url_contains", s: "/status/" }, { t: "text_visible", text: "{{item.tra_loi}}" }], kem_anh: kemAnhHoc(1, X_HAU_KIEM_ANH, { ...X_KEM_ANH, ngu_canh: "{{item.noi_dung}}" }) },
    },
  },
  {
    ten: "dang_bai",
    moTa: "Đăng MỘT bài mới trên X: AI soạn bài ngắn (≤ 280 ký tự) từ hồ sơ sản phẩm/knowledge theo chủ đề cho sẵn; mở /compose/post, gõ, bấm Đăng (rủi ro cao). Dùng độc lập, không cần tim_bai.",
    thamSo: [{ ten: "chu_de", moTa: "chủ đề/ý chính của bài đăng (một câu), ví dụ: giới thiệu tính năng mới, chia sẻ mẹo dùng", kieu: "chuoi", batBuoc: true }],
    params: { chu_de: { type: "string", default: "{{ts.chu_de}}", label: "Chủ đề bài đăng" } },
    // Không hashtag: máy gõ bằng sự kiện tổng hợp, gõ hashtag làm X mở danh sách gợi ý + lớp phủ che nút Đăng (đo thật 2026-09-29, test x-dang-bai).
    yamlSteps: `  - id: soan_bai
    generate:
      input: "Viết MỘT bài đăng X (tối đa 280 ký tự, KHÔNG dùng hashtag, không liên kết) về: {{chu_de}}"
      guide: knowledge
      max_words: 40
      max_chars: 280
    into: bai

  - id: dang_bai
    on: web
    do: "mở trang soạn bài, gõ {{bai}} rồi bấm Đăng"
    expect: "thấy chữ 'đã được gửi'"
    risk: high
    timeout: 60s`,
    // Hậu kiểm: X về /home và hiện toast "Bài đăng của bạn đã được gửi" (giao diện tiếng Việt) — toast tồn tại vài giây, kiểm ngay sau bấm.
    // (08/10/2026, đợt B) bước dang_bai đếm vào hạn mức "đăng bài lên kênh" mỗi ngày — runner SUY từ id bước (han-muc-ngay.ts loaiDemCuaBuoc), KHÔNG khai ở đây để bundle / hash cũ giữ nguyên.
    learned: { dang_bai: { actions: DANG_BAI_ACTIONS, postcondition: [{ t: "dom_exists", sel: '[data-testid="toast"]' }] } },
  },
  {
    ten: "thich_bai",
    moTa: "Thích MỘT bài/trả lời cụ thể trong một luồng (tìm theo chữ nó chứa) — đội nhiều nick cùng đỡ. Bấm lần hai là BỎ thích nên sổ cái ghi ngay khi bấm.",
    thamSo: [
      { ten: "bai_url", moTa: "địa chỉ luồng/bài (https://x.com/<tên>/status/<số>)", kieu: "chuoi", batBuoc: true },
      { ten: "chu_binh_luan", moTa: "một đoạn chữ có trong bài/trả lời cần thích", kieu: "chuoi", batBuoc: true },
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ luồng" }, chu_binh_luan: { type: "string", default: "{{ts.chu_binh_luan}}", label: "Chữ trong bài" } },
    yamlSteps: `  - id: thich_bai
    on: web
    do: "mở {{bai_url}}, bấm Thích ở bài có chữ {{chu_binh_luan}}"
    expect: "bài đó chuyển sang đã thích"
    risk: high
    idempotent: unsafe
    timeout: 40s
    ledger: da_thich`,
    learned: {
      // X đổi data-testid của nút từ "like" sang "unlike" sau khi thích — tín hiệu hậu kiểm chắc chắn.
      thich_bai: { actions: X_THICH_ACTIONS, postcondition: [{ t: "locator_visible", target: { describe: "nút Bỏ thích của bài đó", ladder: [
        { t: "xpath", xpath: `(${X_BAI}//*[@data-testid="unlike"])[1]` },
      ] } }] },
    },
  },
  {
    ten: "tra_loi_mot_bai",
    moTa: "Trả lời ĐÚNG một bài/trả lời của nick khác trong luồng (tìm theo chữ, mở riêng bài đó rồi trả lời tại chỗ). Rủi ro cao — có cổng duyệt.",
    thamSo: [
      { ten: "bai_url", moTa: "địa chỉ luồng/bài chứa trả lời cần đỡ", kieu: "chuoi", batBuoc: true },
      { ten: "chu_binh_luan", moTa: "một đoạn chữ có trong trả lời cần đỡ", kieu: "chuoi", batBuoc: true },
      ...TS_KEM_ANH_TAT_CA,
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ luồng" }, chu_binh_luan: { type: "string", default: "{{ts.chu_binh_luan}}", label: "Chữ trong trả lời" } },
    yamlSteps: `  - id: soan_tra_loi
    generate:
      input: "Trả lời bài này như một người đọc khác (≤ 280 ký tự): {{chu_binh_luan}}"
      guide: knowledge
      max_words: 40
    into: cau_tra_loi

  - id: gui_tra_loi
    on: web
    do: "mở {{bai_url}}, mở riêng bài có chữ {{chu_binh_luan}}, gõ {{cau_tra_loi}} rồi bấm Trả lời"
    expect: "thấy chữ '{{cau_tra_loi}}'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_tra_loi_bl`,
    learned: { gui_tra_loi: { actions: X_TRA_LOI_MOT_ACTIONS, kem_anh: kemAnhHoc(3, X_HAU_KIEM_ANH, { ...X_KEM_ANH, ngu_canh: "{{chu_binh_luan}}" }) } },
  },
  {
    ten: "binh_luan_mot_bai",
    moTa: "Trả lời vào MỘT bài: có địa chỉ (bai_url) → đúng bài đó (nhiều nick cùng vào một bài, mỗi nick một góc nhìn); ĐỂ TRỐNG → bot TỰ TÌM một bài mới nhất theo từ khoá của kịch bản (bước Tìm / sản phẩm / mục tiêu), bỏ bài quảng cáo, quá ngắn, bài của chính nick, bài đã trả lời; có sản phẩm/mục tiêu thì AI chấm bài liên quan; không có bài hợp → không làm gì. Rủi ro cao — có cổng duyệt.",
    thamSo: [
      { ten: "bai_url", moTa: `địa chỉ bài (https://x.com/<tên>/status/<số>) — ${X_MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false },
      { ten: "goc_nhin", moTa: "góc nhìn của nick này", kieu: "chuoi", batBuoc: false },
      ...TS_KEM_ANH_TAT_CA,
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ bài" }, goc_nhin: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của nick này" } },
    yamlSteps: `  - id: soan
    generate:
      input: "Viết trả lời cho bài này (≤ 280 ký tự) với góc nhìn: {{goc_nhin}}"
      guide: knowledge
      max_words: 40
    into: binh_luan

  - id: dang_binh_luan
    on: web
    do: "mở {{bai_url}}, gõ {{binh_luan}} vào ô trả lời rồi bấm Trả lời"
    expect: "thấy chữ '{{binh_luan}}'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_binh_luan`,
    learned: { dang_binh_luan: { actions: X_BINH_LUAN_MOT_ACTIONS, kem_anh: kemAnhHoc(1, X_HAU_KIEM_ANH, { ...X_KEM_ANH, ngu_canh: "{{goc_nhin}}" }) } },
    tuTim: X_TU_TIM_TRA_LOI,
  },
  // ---------- như người (2026-10-01) ----------
  {
    ten: "luot_bang_tin",
    moTa: "Lướt trang đang mở (kết quả tìm, hoặc bảng tin) như người: cuộn tới từng bài, dừng đọc, thỉnh thoảng Thích (tỉ lệ nhỏ, có duyệt), bỏ quảng cáo. Ghi danh sách ds_bai cho bước Trả lời.",
    thamSo: [
      { ten: "so_bai_doc", moTa: "số bài lướt đọc tối đa (1-10)", kieu: "so", batBuoc: true, min: 1, max: 10 },
      { ten: "giay_doc", moTa: "số giây dừng đọc mỗi bài (2-60)", kieu: "so", min: 2, max: 60, macDinh: "6" },
      TS_TI_LE_THICH,
    ],
    params: { ti_le_thich: { type: "string", default: "{{ts.ti_le_thich}}", label: "Tỉ lệ % bài được thích khi lướt (0-30)" } },
    yamlSteps: `  - id: lay_bang_tin
    on: web
    extract: "các bài đang hiện trên bảng tin hoặc kết quả tìm: tac_gia, noi_dung, lien_ket, ma_bai, quang_cao"
    into: ds_bai
    min_items: 1

  - id: doc_bang_tin
    for_each: ds_bai
    max_items: {{ts.so_bai_doc}}
    when: "not item.quang_cao and len(str(item.ma_bai)) > 0"
    on_item_error: skip
    steps:
      - id: cuon_toi_bai
        on: web
        do: "cuộn tới bài {{item.lien_ket}} như người đang lướt"
        timeout: 20s
      - id: doc_bai_luot
        wait: {{ts.giay_doc}}
      - id: thich_bai_luot
        when: "${DK_THICH_LUOT}"
        ly_do_bo_qua: "${LY_DO_CHUA_TOI_LUOT_THICH}"
        on: web
        do: "bấm Thích bài {{item.lien_ket}} đang đọc"
        expect: "bài chuyển sang đã thích"
        risk: high
        idempotent: unsafe
        timeout: 30s
        ledger: da_thich`,
    learned: {
      lay_bang_tin: { extract_spec: POST_LIST_SPEC },
      // Bước con của vòng đọc: phần đã học nằm dưới bước cha (con) — xem gopDaHoc trong shared/tu-dung.ts.
      doc_bang_tin: { con: {
        cuon_toi_bai: { actions: X_LUOT_CUON },
        thich_bai_luot: { actions: X_LUOT_THICH, postcondition: X_LUOT_DA_THICH },
      } },
    },
  },
  {
    ten: "nghi",
    moTa: "Nghỉ một lúc như người thật, không làm gì trên trang — đặt GIỮA hai việc.",
    thamSo: [{ ten: "giay_nghi", moTa: "số giây nghỉ (5-1800)", kieu: "so", min: 5, max: 1800, macDinh: "60" }],
    yamlSteps: `  - id: nghi
    wait: {{ts.giay_nghi}}`,
    learned: {},
  },
  {
    ten: "dang_lai",
    moTa: "Đăng lại (repost) MỘT bài. Có địa chỉ → đúng bài đó; ĐỂ TRỐNG → bot TỰ TÌM một bài mới nhất theo từ khoá của kịch bản (bỏ bài quảng cáo, quá ngắn, bài của chính nick, bài đã đăng lại; có sản phẩm/mục tiêu thì AI chấm liên quan); không có bài hợp → không làm gì. Rủi ro cao — có duyệt; sổ cái chống đăng lại lần hai.",
    thamSo: [{ ten: "bai_url", moTa: `địa chỉ bài (https://x.com/<tên>/status/<số>) — ${X_MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false }],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ bài" } },
    yamlSteps: `  - id: dang_lai_bai
    on: web
    do: "mở {{bai_url}}, bấm Đăng lại rồi chọn Đăng lại"
    expect: "bài chính chuyển sang đã đăng lại"
    risk: high
    idempotent: unsafe
    timeout: 45s
    ledger: da_dang_lai`,
    learned: { dang_lai_bai: { actions: X_DANG_LAI_ACTIONS, postcondition: [{ t: "dom_exists", sel: `${X_BAI_CHINH} [data-testid="unretweet"]` }] } },
    tuTim: X_TU_TIM_DANG_LAI,
  },
  {
    ten: "trich_dan",
    moTa: "Trích dẫn (quote) MỘT bài: đọc bài gốc, AI soạn lời trích ≤ 280 ký tự, không hashtag, rồi đăng. Có địa chỉ → đúng bài đó; ĐỂ TRỐNG → bot TỰ TÌM một bài mới nhất theo từ khoá của kịch bản (bỏ bài quảng cáo, quá ngắn, bài của chính nick, bài đã trích dẫn; có sản phẩm/mục tiêu thì AI chấm liên quan); không có bài hợp → không làm gì. Rủi ro cao — có duyệt.",
    thamSo: [
      { ten: "bai_url", moTa: `địa chỉ bài cần trích dẫn (https://x.com/<tên>/status/<số>) — ${X_MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false },
      { ten: "goc_nhin", moTa: "góc nhìn của nick này khi trích dẫn (ví dụ: người mới dùng, dân trong nghề)", kieu: "chuoi", batBuoc: false },
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ bài" }, goc_nhin: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của nick này" } },
    yamlSteps: `  - id: mo_bai_trich
    on: web
    do: "mở bài {{bai_url}} để đọc"
    expect: "url chứa /status/"

  - id: doc_bai_trich
    on: web
    extract: "chữ của bài đang mở"
    into: bai_goc

  - id: soan_trich_dan
    generate:
      input: "Bài gốc trên X: {{bai_goc}} — viết lời TRÍCH DẪN (quote) ngắn như một người dùng khác đọc thấy đáng chia sẻ, góc nhìn: {{goc_nhin}} (tối đa 280 ký tự, KHÔNG dùng hashtag, không liên kết, không nhắc lại nguyên văn bài gốc)"
      guide: knowledge
      max_words: 40
      max_chars: 280
    into: trich_dan

  - id: gui_trich_dan
    on: web
    do: "mở {{bai_url}}, bấm Đăng lại → Trích dẫn, gõ {{trich_dan}} rồi bấm Đăng"
    expect: "thấy chữ 'đã được gửi'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_trich_dan`,
    learned: {
      mo_bai_trich: { actions: [{ kind: "navigate", url: "{{bai_url}}" }], postcondition: [{ t: "url_contains", s: "/status/" }, { t: "dom_exists", sel: X_BAI_CHINH }] },
      doc_bai_trich: { extract_spec: { mode: "single", target: { describe: "chữ của bài chính", ladder: [{ t: "css", sel: `${X_BAI_CHINH} [data-testid="tweetText"]` }] }, attr: "text" } },
      gui_trich_dan: { actions: X_TRICH_DAN_ACTIONS, postcondition: [{ t: "dom_exists", sel: '[data-testid="toast"]' }] },
    },
    tuTim: X_TU_TIM_TRICH_DAN,
  },
  // ---------- L-72 (2026-10-02): trả lời những người đã trả lời bài của CHÍNH MÌNH ----------
  {
    ten: "tra_loi_phan_hoi",
    moTa: "Mở bài của CHÍNH MÌNH (bai_url; để trống = bài mới nhất của nick đang đăng nhập, mở từ trang Hồ sơ), đọc các trả lời bên dưới, chỉ giữ trả lời của NGƯỜI KHÁC (bỏ của chính mình, quảng cáo, trả lời đã đáp — sổ cái), AI soạn câu đáp ≤ 280 ký tự như tác giả bài, mở từng trả lời và gõ vào ô trả lời tại chỗ rồi bấm Trả lời (rủi ro cao, có duyệt). Dùng độc lập, không cần tim_bai.",
    thamSo: [
      { ten: "so_tra_loi", moTa: "số người tối đa sẽ trả lời trong một lần chạy (1-5)", kieu: "so", batBuoc: true, min: 1, max: 5 },
      { ten: "bai_url", moTa: "địa chỉ bài CỦA MÌNH (https://x.com/<handle của mình>/status/<số>) nếu người dùng đưa; để trống = bài mới nhất của nick đang đăng nhập", kieu: "chuoi", macDinh: "" },
      ...TS_KEM_ANH_TAT_CA,
    ],
    // Tham số kịch bản RIÊNG (bai_ph_url): bai_url là tham số chung của các thao tác MỘT bài khác (thích/đăng lại/trích dẫn) — dùng chung tên thì
    // không ghép được "đăng lại bài X" với "trả lời người trả lời bài mới nhất của mình" trong một kịch bản.
    params: { bai_ph_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ bài của mình (để trống = bài mới nhất)" } },
    // Lọc: chỉ khi đọc được nick và bài chính ĐÚNG là của nick đó (dán nhầm bài người khác → không trả lời ai); handle X không phân biệt hoa thường.
    yamlSteps: `  - id: lay_nick_ph
    on: web
    extract: "nick đang đăng nhập (link Hồ sơ ở thanh bên)"
    into: nick_ph

  - id: mo_bai_ph
    when: "len(bai_ph_url) > 0"
    on: web
    do: "mở bài của mình {{bai_ph_url}}"
    expect: "url chứa /status/"

  - id: mo_ho_so_ph
    when: "len(bai_ph_url) == 0"
    on: web
    do: "bấm Hồ sơ ở thanh bên để mở trang cá nhân của mình"
    expect: "thấy trang hồ sơ"

  - id: mo_bai_moi_ph
    when: "len(bai_ph_url) == 0"
    on: web
    do: "mở bài mới nhất của chính mình trên trang hồ sơ (bỏ bài ghim, bài đăng lại)"
    expect: "url chứa /status/"

  - id: lay_tac_gia_goc_ph
    on: web
    extract: "tác giả bài chính đang mở"
    into: tac_gia_goc_ph

  - id: lay_ma_goc_ph
    on: web
    extract: "số hiệu bài chính đang mở"
    into: ma_goc_ph

  - id: lay_so_tra_loi_ph
    on: web
    extract: "số lượt trả lời của bài chính"
    into: so_tl_ph
    optional: true
    timeout: 8s

  - id: lay_phan_hoi
    on: web
    when: "len(str(so_tl_ph)) == 0 or int(so_tl_ph) > 0"
    ly_do_bo_qua: "${LY_DO_KHONG_TRA_LOI}"
    extract: "các trả lời dưới bài: tac_gia, noi_dung, lien_ket, ma_bai, quang_cao"
    into: ds_phan_hoi
    min_items: 1

  - id: chon_phan_hoi
    when: "len(str(so_tl_ph)) == 0 or int(so_tl_ph) > 0"
    ly_do_bo_qua: "${LY_DO_KHONG_TRA_LOI}"
    filter: "len(nick_ph) > 0 and lower(tac_gia_goc_ph) == lower(nick_ph) and lower(item.tac_gia) != lower(nick_ph) and not item.quang_cao and len(item.noi_dung) > 0 and item.lien_ket not in ledger.da_tra_loi"

  - id: soan_phan_hoi
    when: "len(str(so_tl_ph)) == 0 or int(so_tl_ph) > 0"
    ly_do_bo_qua: "${LY_DO_KHONG_TRA_LOI}"
    for_each: ds_phan_hoi
    max_items: {{ts.so_tra_loi}}
    generate:
      input: "{{item.tac_gia}} vừa trả lời bài của bạn trên X: {{item.noi_dung}} — (bạn là TÁC GIẢ bài gốc: đáp lại họ ngắn gọn, tự nhiên, đúng điều họ nói; không dùng hashtag, không liên kết)"
      guide: knowledge
      max_words: 35
      max_chars: 280
      anh: item.anh_url
    into: item.tra_loi

  - id: gui_phan_hoi
    when: "len(str(so_tl_ph)) == 0 or int(so_tl_ph) > 0"
    ly_do_bo_qua: "${LY_DO_KHONG_TRA_LOI}"
    for_each: ds_phan_hoi
    max_items: {{ts.so_tra_loi}}
    on: web
    do: "mở trả lời {{item.lien_ket}}, gõ {{item.tra_loi}} vào ô trả lời tại chỗ rồi bấm Trả lời"
    expect: "thấy chữ '{{item.tra_loi}}'"
    risk: high
    timeout: 60s
    on_item_error: skip
    ledger: da_tra_loi`,
    learned: {
      lay_nick_ph: { extract_spec: { mode: "single", target: { describe: "link Hồ sơ của nick đang đăng nhập", ladder: [{ t: "css", sel: 'a[data-testid="AppTabBar_Profile_Link"]' }] }, attr: "href", regex: "(/[A-Za-z0-9_]+)/?$" } },
      mo_bai_ph: { actions: [{ kind: "navigate", url: "{{bai_ph_url}}" }], postcondition: [{ t: "url_contains", s: "/status/" }, { t: "dom_exists", sel: X_BAI_CHINH }] },
      // Hậu kiểm phải bắt được trang HỒ SƠ MỚI, không phải trang cũ: trang bài/trang chủ cũng có article → trước đây đạt ngay khi Hồ sơ còn đang tải
      // và bước sau bấm 'bài mới nhất' trên trang CŨ (E2E XP3: mở nhầm bài cũ 2950, nhắm trả lời người dưới bài lạc đề). Đầu trang hồ sơ
      // [data-testid=UserName] chỉ có ở trang hồ sơ (trang bài dùng User-Name) + URL chứa đúng nick.
      mo_ho_so_ph: { actions: [X_PH_HO_SO], postcondition: [{ t: "url_contains", s: "{{nick_ph}}" }, { t: "dom_exists", sel: '[data-testid="UserName"]' }, { t: "dom_exists", sel: 'article[data-testid="tweet"]' }] },
      mo_bai_moi_ph: { actions: [X_PH_BAI_MOI], postcondition: [{ t: "url_contains", s: "{{nick_ph}}/status/" }, { t: "dom_exists", sel: X_BAI_CHINH }] },
      // User-Name của bài có 3 liên kết href "/…" (tên, @handle, giờ đăng /…/status/…) → lấy liên kết ĐẦU (tên) bằng xpath [1] (css "mơ hồ: 3 phần tử").
      lay_tac_gia_goc_ph: { extract_spec: { mode: "single", target: { describe: "tác giả bài chính", ladder: [{ t: "xpath", xpath: '(//article[@data-testid="tweet"][@tabindex="-1"]//*[@data-testid="User-Name"]//a[starts-with(@href, "/")][not(contains(@href, "/status/"))])[1]' }] }, attr: "href", regex: "(/[A-Za-z0-9_]+)/?$" } },
      // Bài CHƯA AI trả lời (X thật 03/10, bài 2105950597904261462: nút Trả lời của bài chính aria-label "0 Lượt trả lời. Trả lời") → bỏ các bước
      // lấy/chọn/soạn/gửi — trước đây danh sách 0 mục rơi xuống nấc 2 (mọi article) và nhắm trả lời bài NGƯỜI LẠ ở "Khám phá thêm" (E2E XP4).
      // Không đọc được số (nhãn đổi) → rỗng → vẫn làm như cũ (min_items bắt danh sách hỏng — XP5).
      lay_so_tra_loi_ph: { extract_spec: { mode: "single", target: { describe: "nút Trả lời của bài chính (nhãn có số lượt trả lời)", ladder: [{ t: "css", sel: 'article[data-testid="tweet"][tabindex="-1"] [data-testid="reply"]' }] }, attr: "aria-label", regex: "^\s*([0-9][0-9.,]*)" } },
      lay_ma_goc_ph: { extract_spec: { mode: "single", target: { describe: "giờ đăng (liên kết) của bài chính", ladder: [{ t: "xpath", xpath: '(//article[@data-testid="tweet"][@tabindex="-1"]//a[contains(@href, "/status/")][.//time])[1]' }, { t: "xpath", xpath: '(//article[@data-testid="tweet"][@tabindex="-1"]//a[contains(@href, "/status/")])[1]' }] }, attr: "href", regex: "/status/([0-9]+)" } },
      lay_phan_hoi: { extract_spec: X_PH_LIST_SPEC },
      gui_phan_hoi: { actions: X_PH_GUI_ACTIONS, postcondition: [{ t: "url_contains", s: "/status/" }, { t: "text_visible", text: "{{item.tra_loi}}" }], kem_anh: kemAnhHoc(2, X_HAU_KIEM_ANH, { ...X_KEM_ANH, ngu_canh: "{{item.noi_dung}}" }) },
    },
  },
]);
